// Traffic-light cycle: 14 s per junction, offset across the grid. North-south is green for 6 s, amber for 1 s, then
// east-west takes over. Returns 2 green, 1 amber, 0 red.
export function lightPhase(j, ns, time) {
  const c = (((time + j * 3.5) % 14) + 14) % 14,
    mine = ns ? c : (c + 7) % 14;
  return mine < 6 ? 2 : mine < 7 ? 1 : 0;
}
